import { render, staticRenderFns } from "./ApprovalExpedientView.vue?vue&type=template&id=10f20286&"
import script from "./ApprovalExpedientView.vue?vue&type=script&lang=js&"
export * from "./ApprovalExpedientView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f20286')) {
      api.createRecord('10f20286', component.options)
    } else {
      api.reload('10f20286', component.options)
    }
    module.hot.accept("./ApprovalExpedientView.vue?vue&type=template&id=10f20286&", function () {
      api.rerender('10f20286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/ApprovalExpedientView.vue"
export default component.exports